// Dev note: this customisation point is heavily inspired by UIFeature flags, though
// with an intention of being used for more complex switching on whether or not a feature
// should be shown.

// Populate this class with the details of your customisations when copying it.

export interface IComponentVisibilityCustomisations {
    /**
     * Determines whether or not the active MatrixClient user should be able to use
     * the given UI component. If shown, the user might still not be able to use the
     * component depending on their contextual permissions. For example, invite options
     * might be shown to the user but they won't have permission to invite users to
     * the current room: the button will appear disabled.
     * @param component - The component to check visibility for.
     * @returns True (default) if the user is able to see the component, false otherwise.
     */
    shouldShowComponent?(component: "UIComponent.sendInvites" | "UIComponent.roomCreation" | "UIComponent.spaceCreation" | "UIComponent.exploreRooms" | "UIComponent.addIntegrations" | "UIComponent.filterContainer" | "UIComponent.roomOptionsMenu"): boolean;
}


// A real customisation module will define and export one or more of the
// customisation points that make up the interface above.
export const ComponentVisibilityCustomisations: IComponentVisibilityCustomisations = {
    // while we don't specify the functions here, their defaults are described
    // in their pseudo-implementations above.
};
